// import { getFamilyListApi } from '@/api/staff';
import { createEventHook } from '@vueuse/core';
import { defineStore } from 'pinia';
import type { LoggedResultData } from 'giime';

export const useAppStore = defineStore('app', () => {
  const showLogin = ref(false);
  const loginResult = createEventHook<LoggedResultData>();
  const triggerLoginResult = loginResult.trigger;
  /**监听登录成功  promise版 */
  const onLoginResultPromise = () =>
    new Promise<LoggedResultData>(resolve => {
      loginResult.on(resolve);
    });
  /**关闭登录弹窗事件 */
  const closeLoginResult = createEventHook();
  const triggerCloseLoginResult = closeLoginResult.trigger;
  /**监听登录弹窗关闭  promise版 */
  const onCloseLoginResultPromise = () =>
    new Promise<undefined>(resolve => {
      closeLoginResult.on(resolve);
    });
  watch(showLogin, newValue => {
    if (!newValue) {
      triggerCloseLoginResult();
    }
  });
  return {
    showLogin,
    triggerLoginResult,
    /** 监听登录成功*/
    onLoginResult: loginResult.on,
    /** 监听登录成功  promise版 */
    onLoginResultPromise,
    /**监听登录弹窗关闭  promise版 */
    onCloseLoginResultPromise,
  };
});
